import { Container, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';

const CareOption = ({
  title,
  body,
  icon,
}: {
  title: string;
  body: string;
  icon?: string;
}) => (
  <Col xs={12} md={6} lg={4}>
    <div className="bg-light-subtle rounded-4 shadow-sm p-4 h-100">
      <div className="d-flex align-items-center mb-2">
        {icon && (
          <img
            src={`/images/icons/${icon}`}
            alt=""
            height="24"
            className="me-2"
          />
        )}
        <h5 className="text-body-emphasis mb-0">{title}</h5>
      </div>
      <p className="mb-0 text-body-secondary">{body}</p>
    </div>
  </Col>
);

const CareOptionsSection = () => (
  <Parallax
    translateY={[10, 0]}
    scale={[0.85, 1]}
    shouldAlwaysCompleteAnimation
  >
    <section className="bg-white py-5 m-5">
      <Container>
        <Row className="g-4">
          <CareOption
            title="In Person or Virtually"
            body="Meet with a dietitian in person or virtually—whatever fits your schedule and comfort."
            icon="headset.svg"
          />
          <CareOption
            title="Pay With Insurance"
            body="Most insurance plans cover our services, meaning you may pay little or nothing out of pocket."
            icon="cash-stack.svg"
          />
          <CareOption
            title="Nutrition Counseling"
            body="Our skilled dietitians offer expert nutrition advice that’s accessible and insurance-friendly."
            icon="fork-knife.svg"
          />
          <CareOption
            title="Medical Interpreters"
            body="Professional interpreters are available to support your language needs during appointments."
            icon="translate.svg"
          />
          <CareOption
            title="Weight-Inclusive Care"
            body="We follow a Health at Every Size® philosophy—prioritizing respect, well-being, and evidence-based care."
            icon="people-fill.svg"
          />
          <CareOption
            title="Chronic Condition Support"
            body="Receive tailored nutrition guidance for managing chronic conditions like heart or kidney disease."
            icon="bookmark-heart-fill.svg"
          />
        </Row>
      </Container>
    </section>
  </Parallax>
);

export default CareOptionsSection;
